import { render } from "./MembershipEdit.vue?vue&type=template&id=53130fc2"
import script from "./MembershipEdit.vue?vue&type=script&lang=js"
export * from "./MembershipEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__